// imports
import DrupalView from 'minsky-kit/js/components/DrupalView';

// private statics

// class definition
export default class CTDrupalView extends DrupalView {
    // constructor
    constructor (args = {}, objectName = 'DrupalView') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);
    }

    // methods
    refresh (...args) {
        super.refresh(...args);
    }

    show (...args) {
        super.show(...args);
    }

    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
